import { render, staticRenderFns } from "./DriverAssignment.vue?vue&type=template&id=4d95918c&scoped=true&"
import script from "./DriverAssignment.vue?vue&type=script&lang=js&"
export * from "./DriverAssignment.vue?vue&type=script&lang=js&"
import style0 from "./DriverAssignment.vue?vue&type=style&index=0&id=4d95918c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95918c",
  null
  
)

export default component.exports